import React, { MouseEventHandler } from "react";
import Tooltip from "@mui/material/Tooltip";
import styles from "./IconButton.module.css";

interface IconButtonProps {
    onClick: MouseEventHandler<HTMLButtonElement>;
    disabled?: boolean;
    disabledTitle?: string;
    IconComponent: React.FC<React.SVGProps<SVGSVGElement>>;
    title: string;
    iconSize?: number;
    isSelected?: boolean;
}

const IconButton: React.FC<IconButtonProps> = ({
    onClick,
    disabled = false,
    disabledTitle,
    title,
    iconSize = 24,
    IconComponent,
    isSelected = false,
}) => (
    <Tooltip title={disabled && disabledTitle ? disabledTitle : title} arrow placement="top">
        <span>
            <button
                onClick={onClick}
                disabled={disabled}
                className={[styles.iconButton, disabled ? styles.disabled : "", isSelected ? styles.selected : ""]
                    .filter(Boolean)
                    .join(" ")}
            >
                <IconComponent
                    className={`${styles.iconButtonIcon} ${disabled ? styles.disabled : ""}`}
                    style={{
                        width: iconSize,
                        height: iconSize,
                    }}
                />
            </button>
        </span>
    </Tooltip>
);

export default IconButton;
